import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import { API_URL } from '../../config/api';
import './SaveScenarioModal.css';

const SaveScenarioModal = ({ isOpen, onClose, propertyId, assumptions, results, onSaved }) => {
    const { session } = useAuth();
    const { showToast } = useToast();
    const [name, setName] = useState('');
    const [saving, setSaving] = useState(false);

    if (!isOpen) return null;

    const handleSave = async () => {
        if (!name.trim()) {
            showToast('Please enter a scenario name', 'error');
            return;
        }

        setSaving(true);
        try {
            const response = await fetch(`${API_URL}/scenarios`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${session?.access_token}`
                },
                body: JSON.stringify({
                    property_id: propertyId,
                    name: name.trim(),
                    assumptions,
                    results
                })
            });

            if (response.ok) {
                showToast('Scenario saved!', 'success');
                setName('');
                onSaved?.();
                onClose();
            } else {
                showToast('Failed to save scenario', 'error');
            }
        } catch (error) {
            console.error(error);
            showToast('Error saving scenario', 'error');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="save-scenario-modal" onClick={e => e.stopPropagation()}>
                <h3 className="ssm-title">Save Scenario</h3>
                <p className="ssm-subtitle">Give this scenario a name to save your assumptions and results.</p>

                <div className="ssm-field">
                    <label>Scenario Name</label>
                    <input
                        type="text"
                        className="std-input"
                        placeholder="e.g. Conservative, Best Case, 25% Down..."
                        value={name}
                        onChange={e => setName(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && handleSave()}
                        autoFocus
                    />
                </div>

                <div className="ssm-actions">
                    <button className="ssm-btn-cancel" onClick={onClose}>Cancel</button>
                    <button
                        className="ssm-btn-save"
                        onClick={handleSave}
                        disabled={saving}
                    >
                        {saving ? 'Saving...' : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SaveScenarioModal;
